(function () {
  var VEHICLES = {
    'Toyota': ['Tacoma', 'Tundra', '4Runner', 'Land Cruiser', 'Sequoia', 'FJ Cruiser', 'RAV4', 'Highlander', 'Hilux'],
    'Ford': ['F-150', 'F-150 Raptor', 'F-250 Super Duty', 'F-350 Super Duty', 'Ranger', 'Bronco', 'Bronco Sport', 'Expedition', 'Explorer', 'Excursion'],
    'Chevrolet': ['Silverado 1500', 'Silverado 2500HD', 'Silverado 3500HD', 'Colorado', 'Tahoe', 'Suburban', 'Avalanche'],
    'GMC': ['Sierra 1500', 'Sierra 2500HD', 'Sierra 3500HD', 'Canyon', 'Yukon', 'Hummer EV'],
    'Ram': ['1500', '1500 TRX', '2500', '2500 Power Wagon', '3500'],
    'Jeep': ['Wrangler', 'Gladiator', 'Grand Cherokee', 'Cherokee', 'Wagoneer'],
    'Nissan': ['Frontier', 'Titan', 'Xterra', 'Pathfinder', 'Armada'],
    'Lexus': ['GX', 'LX'],
    'Honda': ['Ridgeline', 'Pilot', 'Passport'],
    'Subaru': ['Outback', 'Forester', 'Crosstrek'],
    'Land Rover': ['Defender', 'Discovery', 'Range Rover'],
    'Rivian': ['R1T', 'R1S'],
    'INEOS': ['Grenadier'],
    'Mercedes-Benz': ['G-Class', 'Sprinter'],
    'Mitsubishi': ['Montero', 'Outlander'],
    'Hyundai': ['Santa Cruz'],
    'Isuzu': ['Trooper', 'Rodeo']
  };
  var OTHER = 'Other / not listed';
  function el(tag, attrs, text) { var e = document.createElement(tag); for (var k in attrs) e.setAttribute(k, attrs[k]); if (text != null) e.textContent = text; return e; }
  function fill(sel, placeholder, values) {
    sel.textContent = '';
    sel.appendChild(el('option', { value: '' }, placeholder));
    values.forEach(function (v) { sel.appendChild(el('option', { value: v }, v)); });
  }
  function save(v) { try { localStorage.setItem('se_vehicle', JSON.stringify(v)); } catch (e) {} }
  function load() { try { return JSON.parse(localStorage.getItem('se_vehicle') || 'null'); } catch (e) { return null; } }

  function init(root) {
    var dataEl = root.querySelector('[data-fit-data]');
    var data = {}; try { data = JSON.parse(dataEl.textContent); } catch (e) {}
    var kits = data.kits || [];
    var flex = data.flex || {};
    var mk = root.querySelector('[data-fit="make"]'), md = root.querySelector('[data-fit="model"]'), yr = root.querySelector('[data-fit="year"]');
    var res = root.querySelector('[data-fit-result]');
    var pkg = 'max';
    var makes = Object.keys(VEHICLES).sort(); makes.push(OTHER);
    fill(mk, 'Select make', makes);
    fill(md, 'Select model', []); md.disabled = true;
    var years = []; for (var y = data.maxYear || 2027; y >= 1990; y--) years.push(String(y));
    fill(yr, 'Select year', years); yr.disabled = true;

    function match(make, model, year) {
      var y = parseInt(year, 10);
      for (var i = 0; i < kits.length; i++) {
        var k = kits[i];
        if (k.make === make && k.model === model && y >= k.from && y <= k.to) return k;
      }
      return null;
    }
    function render(scroll) {
      var make = mk.value, model = md.value, year = yr.value;
      var other = make === OTHER;
      var done = other || (make && model && year);
      root.classList.toggle('is-lit', !!done);
      root.classList.toggle('is-max', pkg === 'max');
      root.querySelectorAll('[data-pkg]').forEach(function (b) { b.setAttribute('aria-pressed', b.dataset.pkg === pkg ? 'true' : 'false'); });
      root.querySelector('[data-fit-toggle]').hidden = !done;
      res.hidden = !done;
      if (!done) { var h0 = root.querySelector('.se-truckbox__hint'); if (h0) h0.textContent = 'PICK YOUR TRUCK TO LIGHT IT UP'; return; }
      var vehicle = other ? '' : (year + ' ' + make + ' ' + model);
      var hint = root.querySelector('.se-truckbox__hint'); if (hint) hint.textContent = other ? 'FULL-PERIMETER COVERAGE' : vehicle.toUpperCase();
      var kit = other ? null : match(make, model, year);
      var r = kit || flex;
      var q = function (s) { return res.querySelector(s); };
      q('[data-r-img]').src = r.img || '';
      q('[data-r-img]').classList.toggle('is-flatlay', !kit);
      q('[data-r-img]').alt = kit ? (vehicle + ' Shadow Eliminator kit') : 'Shadow Eliminator FLEX kit';
      q('[data-r-eyebrow]').textContent = kit ? 'BOLT-ON KIT FOR YOUR ' + model.toUpperCase() : (other ? 'FITS ANY BUILD' : 'FITS YOUR ' + model.toUpperCase());
      q('[data-r-name]').textContent = kit ? ('Shadow Eliminator for your ' + vehicle) : (other ? 'Shadow Eliminator FLEX' : 'Shadow Eliminator FLEX for your ' + vehicle);
      var list = q('[data-r-points]'); list.textContent = '';
      var points = (kit ? (data.boltPoints || []) : (data.flexPoints || [])).map(function (p) { return String(p).trim(); }).filter(Boolean);
      points.forEach(function (p) {
        var txt = p.replace('[vehicle]', other ? 'your truck' : model).replace('[full]', other ? 'your truck' : vehicle);
        var li = el('li'); li.innerHTML = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#F5A524" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12.5l4.5 4.5L19 7.5"></path></svg>';
        li.appendChild(document.createTextNode(txt)); list.appendChild(li);
      });
      var url = r.url || '#';
      var link = q('[data-r-link]');
      link.href = url;
      link.textContent = kit ? ('See my ' + model + ' kit') : (other ? 'Shop FLEX' : 'Shop FLEX for my ' + model);
      q('[data-r-price]').textContent = 'From ' + r.price + ' · free shipping · or 4 interest-free payments';
      var alt = q('[data-r-alt]');
      if (kit && flex.url) { alt.hidden = false; alt.querySelector('a').href = flex.url; } else { alt.hidden = true; }
      save({ vehicle: vehicle, make: make, model: model, year: year, kit: kit ? kit.handle : 'flex' });
      if (scroll) setTimeout(function () { var mob = window.matchMedia('(max-width: 749px)').matches; (mob ? root.querySelector('.se-truckbox') : res).scrollIntoView({ behavior: 'smooth', block: mob ? 'start' : 'nearest' }); }, 250);
    }
    mk.addEventListener('change', function () {
      var models = VEHICLES[mk.value] || [];
      fill(md, 'Select model', models); md.disabled = !models.length;
      yr.value = ''; yr.disabled = true;
      render(mk.value === OTHER);
      if (models.length) md.focus();
    });
    md.addEventListener('change', function () { yr.disabled = !md.value; yr.value = ''; render(false); if (md.value) yr.focus(); });
    yr.addEventListener('change', function () { render(true); });
    root.querySelectorAll('[data-pkg]').forEach(function (b) { b.addEventListener('click', function () { pkg = b.dataset.pkg; render(false); }); });
    var prev = load();
    if (prev && prev.make && VEHICLES[prev.make]) {
      mk.value = prev.make; fill(md, 'Select model', VEHICLES[prev.make]); md.disabled = false; md.value = prev.model || '';
      yr.disabled = !md.value; yr.value = prev.year || ''; render(false);
    }
  }
  function boot() { document.querySelectorAll('[data-se-fit]').forEach(function (r) { if (!r.dataset.ready) { r.dataset.ready = '1'; init(r); } }); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
